import { useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {
  API,
  VibeModal,
  GlobalActions,
  TableFlights,
  SidePanelContainer,
  SidePanelHeader,
  SidePanelContent,
  VibeIcon,
  viClose,
  color,
} from 'vibeguide';
import C, { lower } from 'constants';

function SegmentFlights({
  className = '',
  user,
  flightId = '',
  segmentStartDate,
  segmentEndDate,
  segmentDayParts = [],
  setPanel,
  onUpdate = () => {},
}) {
  const [confirmFlightSelection, setConfirmFlightSelection] = useState(false);
  const [selectedFlight, setSelectedFlight] = useState(null);

  const onClose = () => {
    setPanel({
      extraPanel: {
        show: false,
      },
      thirdPanel: {
        show: false,
      },
    });
  };

  const onCloseFlights = (flight) => {
    if (!flight) {
      onClose();
      return;
    }

    setSelectedFlight(flight);

    const hasCreatives = segmentDayParts.reduce((acc, dayPart) => {
      const dayPartHasCreatives = dayPart.dateRanges.reduce((drAcc, dateRange) => {
        if (dateRange.creatives && dateRange.creatives.length > 0) {
          return true;
        }
        return drAcc;
      }, false);

      if (dayPartHasCreatives) {
        return true;
      }
      return acc;
    }, false);

    // if the flight is not vibenomics and there are multiple day-parts or creatives, confirm dayparts will reset
    if (flight.adProvider !== 'vibenomics' && (segmentDayParts.length > 1 || hasCreatives)) {
      setConfirmFlightSelection(true);
    } else {
      onUpdate({
        flightId: flight._id,
      });

      onClose();
    }
  };

  /**
   * When a flight is selected from the table
   */
  const onSelectFlight = (flight) => {
    onCloseFlights(flight);
  };

  const onConfirmFlightSelection = () => {
    setConfirmFlightSelection(false);

    onUpdate({
      flightId: selectedFlight._id,
      dayParts: [{
        startTime: '',
        endTime: '',
        dateRanges: [],
      }],
    });

    onClose();
  };

  const onCloseFlightSelection = () => {
    setConfirmFlightSelection(false);
    setSelectedFlight(null);
  };

  return (
    <SidePanelContainer className={classNames('SegmentFlights', className)}>
      <SidePanelHeader
        style={{
          borderBottom: 'none',
        }}
        icons={(
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <VibeIcon
              className="close"
              icon={viClose}
              color={color.manatee}
              hoverColor={color.obsidian}
              size={24}
              onClick={onClose}
            />
          </div>
        )}
      >
        <div className="title">
          Select {C.PROPOSAL}
        </div>
      </SidePanelHeader>

      <SidePanelContent
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 0,
        }}
      >
        <TableFlights
          columns={[
            'Select',
            'Name',
            `${C.PROPOSAL} Type`,
            'Status',
            'Creative',
            'Opportunity',
            'Opportunity ID',
            'Deal ID',
            'Order Reference ID',
            'Ad Provider',
            'Currency',
            'Start Date',
            'End Date',
            'Created By',
            'Created Date',
            '...',
          ]}
          // highlight the assigned flight
          highlight={[{
            _id: flightId,
          }]}
          available
          fetch={API.Flight.list}
          defaultSortBy={{
            label: 'Name',
            attr: 'name',
            direction: 'asc',
          }}
          paginator
          paginatorProps={{
            label: C.PROPOSALS,
            urlPaging: false,
            urlFilters: false,
          }}
          onSelectFlight={onSelectFlight}
        />
      </SidePanelContent>

      <VibeModal
        show={confirmFlightSelection}
        type="confirm"
        title={`${C.PROPOSAL} Select Confirmation`}
        onConfirm={onConfirmFlightSelection}
        onClose={onCloseFlightSelection}
      >
        <>
          <div>The ${lower(C.PROPOSAL)} you have selected has an Ad Provider that is not Vibenomics.</div>
          <div style={{ fontWeight: 'bold' }}>Your day-parts and assigned media will be removed.</div>
        </>
      </VibeModal>
    </SidePanelContainer>
  );
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default connect(mapStateToProps, mapDispatchToProps)(SegmentFlights);
